import QueryOptions from './queryServiceStrategy/QueryOptions';
import ODATA_2_QUERY_SERVICE_STATEGY from './queryServiceStrategy/OData2ServiceStrategy';
import ODATA_4_QUERY_SERVICE_STATEGY from './queryServiceStrategy/OData4ServiceStrategy';
import { OData4WithOffsetServiceStrategy } from './queryServiceStrategy/OData4WithOffsetServiceStrategy';

let queryServiceStrategy = ODATA_2_QUERY_SERVICE_STATEGY;

function escapef(input) {
  const newInput = encodeURIComponent(input);
  const path = "'";
  return newInput.replace(new RegExp(path, 'g'), "''");
}

function resolve(opt, first, second, func) {
  return queryServiceStrategy.resolve(opt, first, second, func);
}

function resolveFilter(field, values) {
  return queryServiceStrategy.resolveFilter(field, values);
}

/**
 * OData version 4 is different from OData previous versions.
 * Query services assume OData 2 as default.
 * If you want to use OData 4 (BE Framework >= 3.1), you have to declare it.
 */
function useODataVersion4() {
  queryServiceStrategy = ODATA_4_QUERY_SERVICE_STATEGY;
}

/**
 * OData version 4 is different from OData previous versions.
 * Query services assume OData 2 as default.
 * If you want to use OData 4 (BE Framework >= 3.1), you have to declare it.
 *
 * The queries with a date consider the current offset.
 * So 12/01/2020 00:00:00 +2:00 creates a query with 2020-01-11T22:00:00Z
 *
 * @param {int} offset offset in minuti
 */
function useODataVersion4WithOffset(offset) {
  queryServiceStrategy = new OData4WithOffsetServiceStrategy(offset);
}
/**
 * OData version 4 is different from OData previous versions.
 * Query services assume OData 2 as default.
 * If you want to use OData 2 (BE Framework < 3.1), you have to declare it.
 */
function useODataVersion2() {
  queryServiceStrategy = ODATA_2_QUERY_SERVICE_STATEGY;
}

export {
  QueryOptions,
  resolveFilter,
  resolve,
  escapef as escape,
  useODataVersion4,
  useODataVersion2,
  useODataVersion4WithOffset,
};
